import { render, staticRenderFns } from "./basePagePop.vue?vue&type=template&id=8014ff5e&scoped=true"
import script from "./basePagePop.vue?vue&type=script&lang=js"
export * from "./basePagePop.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"
import style1 from "./basePagePop.vue?vue&type=style&index=1&id=8014ff5e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8014ff5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8014ff5e')) {
      api.createRecord('8014ff5e', component.options)
    } else {
      api.reload('8014ff5e', component.options)
    }
    module.hot.accept("./basePagePop.vue?vue&type=template&id=8014ff5e&scoped=true", function () {
      api.rerender('8014ff5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/basePagePop.vue"
export default component.exports